/* eslint-disable no-underscore-dangle */
import FlickityClass from "common/utils/ui/flickity-class";
import "./digital-assets-pdp-slider.scss";

export class DigitalAssetsPdpSlider extends FlickityClass {
  #heightObserver;

  #initResizeObserver() {
    if (this.$flickity && !this.#heightObserver) {
      this.#heightObserver = new ResizeObserver(([carousel]) =>
        this.#updateCarouseAlignment(carousel)
      );
      this.#heightObserver.observe(this.$flickity);
    }
  }

  #updateCarouseAlignment(carousel) {
    const { height } = carousel.contentRect;
    const option = {
      cellAlign: height === 8 ? "center" : "left" // 8 is the default height of the carousel on mobile
    };
    this.addOrModifyOptions(option);
  }

  async initFlickity() {
    await super.initFlickity();
    this.#initResizeObserver();
  }
}

export default () =>
  new DigitalAssetsPdpSlider(".js-digital-assets-pdp-slider", {
    asNavFor: ".js-digital-assets-pdp-image-carousel",
    contain: true,
    draggable: false,
    pageDots: false,
    percentPosition: false,
    groupCells: "100%"
  }).initFlickity();
